import React from 'react';
import { ChartTypes, ChartData } from '@scholastic/volume-react';
import { LineBarChart } from '@scholastic/volume-react/dist/charts';

export interface ReportChartProps {
  /**
   * This holds the main chart data
   */
  graphData: ChartData | undefined;

  /**
   * This holds the type of the chart 'line | bar'
   * @default 'bar'
   */
  chartType: ChartTypes;
}

const ReportChart = ({ graphData, chartType }: ReportChartProps) => {
  return (
    <LineBarChart
      graphProp={graphData ? graphData : []}
      chartType={chartType}
      showLegend={true}
      tooltipType={'axis'}
      rotateLabel={0}
      rotateXaxesLabel={40}
      renderer={'svg'}
    />
  );
};

export default ReportChart;
